// UTM Parameter Tracking
(function() {
  const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  /**
   * Get UTM parameters from URL and save to sessionStorage
   */
  function captureUTMParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    let hasNewParams = false;

    UTM_PARAMS.forEach(param => {
      const value = urlParams.get(param);
      if (value) {
        sessionStorage.setItem(param, value);
        hasNewParams = true;
      }
    });

    return hasNewParams;
  }

  /**
   * Get stored UTM parameters from sessionStorage
   */
  function getStoredUTMParameters() {
    const params = {};
    UTM_PARAMS.forEach(param => {
      const value = sessionStorage.getItem(param);
      if (value) {
        params[param] = value;
      }
    });
    return params;
  }

  /**
   * Populate UTM fields in all forms (only if field is empty)
   */
  function populateUTMFields() {
    const utmParams = getStoredUTMParameters();

    // Find all forms with UTM fields
    const $forms = $('form');

    $forms.each(function() {
      const $form = $(this);

      // Map utm_param to Salesforce field names
      const fieldMapping = {
        'utm_campaign': 'UTM_Campaign__c',
        'utm_content': 'UTM_Content__c',
        'utm_medium': 'UTM_Medium__c',
        'utm_source': 'UTM_Source__c',
        'utm_term': 'UTM_Term__c'
      };

      UTM_PARAMS.forEach(param => {
        const value = utmParams[param];

        if (value) {
          // Try different field name formats
          const selectors = [
            `input[name="${param}"]`,                    // Standard: utm_campaign
            `input[name="${fieldMapping[param]}"]`       // Salesforce: UTM_Campaign__c
          ];

          selectors.forEach(selector => {
            const $field = $form.find(selector);
            if ($field.length > 0 && !$field.val()) {
              // Only populate if field is empty
              $field.val(value);
            }
          });
        }
      });
    });
  }

  // Capture UTM parameters on page load
  captureUTMParameters();

  // Populate forms when DOM is ready
  $(document).ready(function() {
    populateUTMFields();
  });
})();

// Multi-select handling for forms
const $forms = $('.default-content .easee-form');

if($forms.length > 0) {
  $forms.each(function(index, form) {
    let $select = $(form).find('select[multiple]');

      $select.find('option').mousedown(function (e) {
      let $this = $(this);

      e.preventDefault();
      $this.prop('selected', !$this.prop('selected'));

      return false;
    });
  });
}